import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import { SetupPasswordPayload, ActivateCardPayload, OnboardingSuccessResponse } from '../types/onboarding.types';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';

const emptySession = {};

export const onboardingService = {
    /**
     * Validates the invite token upon loading the page
     */
    acceptInvite: async (token: string): Promise<OnboardingSuccessResponse> => {
        const newHeaders = buildCommonHeaders({
            withLocation: true
        });
        const response = await apiClient.post<OnboardingSuccessResponse>(
            API_ENDPOINTS.onboarding.acceptInvite,
            { data: { token }, session: emptySession },
            { headers: newHeaders }
        );

        return response.data.data
    },

    /**
     * Sets the password and logs the user in (returns session context theoretically)
     */
    setupPassword: async (payload: SetupPasswordPayload): Promise<OnboardingSuccessResponse> => {
        return apiClient.post<OnboardingSuccessResponse>(
            API_ENDPOINTS.onboarding.setupPassword,
            { data: { data: payload } }
        );
    },

    /**
     * Activates the physical card with PAN segment and exact NIP
     */
    activateCard: async (payload: ActivateCardPayload): Promise<OnboardingSuccessResponse> => {
        const newHeaders = buildCommonHeaders({
            withLocation: true
        });

        return apiClient.post<OnboardingSuccessResponse>(
            API_ENDPOINTS.onboarding.activateCard,
            { data: payload, session: emptySession },
            { headers: newHeaders }
        );
    }
};
